import { format, parse } from 'date-fns';
import { createContext, useEffect, useState } from 'react';

export const CalendarContext = createContext();

export const CalendarProvider = ({
  children,
  storageKey,
  setCurrentMonth,
  currentMonth,
}) => {
  const [years, setYears] = useState([]);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  useEffect(() => {
    let yearsArr = [];
    const today = new Date();
    let todayYear = today.getFullYear() + 5;
    for (let i = 2023; i <= todayYear; i++) {
      yearsArr.push(i);
    }

    setYears(yearsArr);
  }, []);

  const onSelectTime = (
    e,
    getRequestCurrentMonthAndYear,
    inputMonth,
    inputYear,
    sortByDateNeeded = true
  ) => {
    e.preventDefault();
    let newDate = parse(
      `${Number(inputMonth) + 1} ${inputYear}`,
      'M yyyy',
      new Date()
    );
    setCurrentMonth(format(newDate, 'MMM yyyy'));
    localStorage.setItem(storageKey, format(newDate, 'MMM yyyy'));
    let month = parseInt(inputMonth) + 1;
    if (month > 12) {
      month = 1;
    }
    getRequestCurrentMonthAndYear(
      Number(inputMonth) + 1,
      inputYear,
      sortByDateNeeded
    );
  };

  return (
    <CalendarContext.Provider
      value={{
        currentMonth,
        setCurrentMonth,
        storageKey,
        years,
        months,
        onSelectTime,
      }}>
      {children}
    </CalendarContext.Provider>
  );
};
